export class Dictionary {
    id: number;
    destinazionePlanimetria: string;
    destinazioneNormalizzata: string;
    macrogruppo: string;
    coefficienteCalcoloSupTari: number;

    constructor() {
        this.id = null;
        this.coefficienteCalcoloSupTari = null;
        this.destinazioneNormalizzata = null;
        this.destinazionePlanimetria = null;
        this.macrogruppo = null;
    }
}

export enum DictToJSON {
    destinazionePlanimetria = 'DESTINAZIONE PLANIMETRIA',
    destinazioneNormalizzata = 'DESTINAZIONE NORMALIZZATA',
    macrogruppo = 'MACROGRUPPO',
    coefficienteCalcoloSupTari = 'COEFFICIENTE CALCOLO SUP TARI'
}